import type { TMe, TNotificationSummary } from '../types/organization'
import { axios } from 'configs'

export const getMe = async (): Promise<TMe> => {
  const response = await axios.get<TMe>('me')
  return response.data
}

/** 組織の指定は不要。全 ACTIVE 所属の未読数を一括で返す（設計書 §7.2） */
export const getNotificationSummary = async (): Promise<TNotificationSummary> => {
  const response = await axios.get<TNotificationSummary>(
    'me/notification-summary',
  )
  return response.data
}
